import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./WeddingFeatures.css";
import ModalBooking from "../../ModalBooking/ModalBooking";

import { useDispatch , useSelector} from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode"; // Fixed import (no need to destructure)
const {
  ShowUserEvents,
} = require("../../../../context/Slice/EventManagementSlice");

const WeddingFeatures = ({ disabledCards }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
const EventData = useSelector((state)=> state.EventManagementR.Data || [])

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State for form values
  const [formValue, setFormValue] = useState({
    User_id: "NA", // Default values set to "NA"
    Coordinator_id: "NA",
    Event_id: "NA",
    fullName: "",
    email: "",
    mobile_number: "",
    note: "",
  });

  const token = secureLocalStorage.getItem("token");

  const handleCoordinatorClick = (coordinatorId, userId) => {
    console.log("Coordinator ID:", coordinatorId);
    console.log("User ID:", userId);

    // Set modal data and open it
    setModalData({ Coordinator_id: coordinatorId, User_id: userId });
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // const handleProceed = () => {
  //   // Navigate after closing the modal
  //   navigate("/EventCoordinator-list", {
  //     state: {
  //       formDetails: modalData,
  //     },
  //   });
  // };

  // Decode token and update `formValue`
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("Decoded Token:", decoded); // Log decoded token for debugging

        // Update User_id based on decoded token
        setFormValue((prevState) => ({
          ...prevState,
          User_id: decoded._id || "NA", // Fallback to "NA" if `_id` is missing
        }));

        // Dispatch action with User ID
        dispatch(ShowUserEvents(decoded._id));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    } else {
      console.warn("Token is missing or invalid.");
    }
  }, [token, dispatch]);

  // Log updated formValue for debugging
  useEffect(() => {
    console.log("Updated formValue:", formValue);
  }, [formValue]);

  console.log(EventData)

  const iduser = localStorage.getItem("userId")

  const FilterEventData = EventData.filter((data) => String(iduser) === data.User_id).map((data)=>data);
  console.log(FilterEventData);
  

  return (
    <div>
      <section id="card-wed-fri">
        <div className="container">
          <div className="row align-items-center">
            <div className="centered-container">
              <h2
                className="section-heading"
                data-aos="zoom-in-down"
                data-aos-delay="100"
                data-aos-duration="900"
              >
                Experience the Magic
              </h2>
              <p
                className="section-para text-border"
                data-aos="zoom-in-up"
                data-aos-delay="150"
                data-aos-duration="900"
              >
                "Discover the enchanting moments that make our cosmic events
                unforgettable."
              </p>
            </div>
          </div>
          <div className="row align-items-center cards">
            {/* Budget Card */}
            <div
              className={`col ${disabledCards?.budget ? "disabled" : ""}`}
              data-aos="fade-right"
              data-aos-delay="300"
              data-aos-duration="400"
            >
              <div className="card">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/Budget.png"
                      alt="budget"
                    />
                    <h3>View/Update Budget</h3>
                    <p>Modify or review event budget easily.</p>
                    {!disabledCards?.budget && (
                      <a href="/view&update-Budget-tool">Read More</a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Guest List Card */}
            <div
              className={`col ${disabledCards?.guestList ? "disabled" : ""}`}
              data-aos="fade-right"
              data-aos-delay="500"
              data-aos-duration="400"
            >
              <div className="card">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/guests.png"
                      alt="guest"
                    />
                    <h3>Guest List</h3>
                    <p>Effortlessly manage, track, and organize your event guests in one place.</p>
                    {!disabledCards?.guestList && (
                      <a href="/user/guest-list">Read More</a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Check List Card */}
            <div
              className={`col ${disabledCards?.checkList ? "disabled" : ""}`}
              data-aos="zoom-in-down"
              data-aos-delay="600"
              data-aos-duration="500"
            >
              <div className="card">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/checklist.png"
                      alt="check list"
                    />
                    <h3>Check List</h3>
                    <p>Keep track of tasks and stay organized for a seamless event planning experience.</p>
                    {!disabledCards?.checkList && (
                      <a href="/CheckList-Page">Read More</a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Coordinator Card */}
            {/* <div
              className={`col ${disabledCards?.coordinator ? "disabled" : ""}`}
              data-aos="fade-left"
              data-aos-delay="300"
              data-aos-duration="400"
            >
              <div className="card">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/counselling.png"
                      alt="RVPS"
                    />
                    <h3>Connect your co-ordinator</h3>
                    <p>Labore, totam velit? Iure nemo labore inventore?</p>
                    {!disabledCards?.coordinator && (
                      <a href="/EventCoordinator-list">Read More</a>
                    )}
                  </div>
                </div>
              </div>
            </div> */}
            <div
              className={`col ${disabledCards?.coordinator ? "disabled" : ""}`}
              data-aos="fade-left"
              data-aos-delay="300"
              data-aos-duration="400"
            >
              <div className="card" id="ConnectYourCoordinator">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/counselling.png"
                      alt="RVPS"
                    />
                    <h3>Connect your co-ordinator</h3>
                    <p>Seamlessly link with your coordinator!</p>
                    {!disabledCards?.coordinator && (
                      <a
                        onClick={() => handleCoordinatorClick(FilterEventData[0].Coordinator_id, FilterEventData[0].User_id)} // Example IDs
                      >
                        Read More
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Vendor Search Card */}
            <div
              className={`col ${disabledCards?.vendorSearch ? "disabled" : ""}`}
              data-aos="fade-left"
              data-aos-delay="500"
              data-aos-duration="400"
            >
              <div className="card">
                <div className="box">
                  <div className="content">
                    <img
                      src="assets/Images/featureCardImages/venderMng.png"
                      alt="Vendor Manager"
                    />
                    <h3>Search your vendors</h3>
                    <p>Find the perfect vendors instantly!</p>
                    {!disabledCards?.vendorSearch && (
                      <a href="/SearchVendor-Page">Read More</a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
            {/* ModalBooking Component */}
      {isModalOpen && (
        <div id="Wedlisting" className="modal-wrapper">
          <ModalBooking
            closeModal={() => setIsModalOpen(false)} // Explicit function
            cor_id={modalData.Coordinator_id}
          />
        </div>
      )}
        </div>
      </section>
    </div>
  );
};

export default WeddingFeatures;
